import { SVGProps } from 'react';

const Settings2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 17H5m9 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0m5-10h-9m0 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default Settings2;
